import styled from "styled-components";
import { PageWrapper } from "BaseComponents/Wrappers";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const PagePuffContainer = styled.div`
  padding: 0 3rem;

  ${media.lessThan(breakpoints.ipad)`
  		padding: ${({ smallpadding }) => (smallpadding ? smallpadding : "1rem")};
  	`}
  ${media.lessThan(breakpoints.mobile)`
  		padding: 0;
  	`}
`;
export const PagePuffOuterWrapper = styled.div`
  background-color: ${({ bgColor }) => (bgColor ? `#${bgColor}` : "#fff")};
`;
